// extracted by mini-css-extract-plugin
export var brief = "newsroomArticleCard-module--brief--746ac";
export var image = "newsroomArticleCard-module--image--dacb8";
export var imageWrapper = "newsroomArticleCard-module--image-wrapper--86219";
export var newsroomArticleCard = "newsroomArticleCard-module--newsroom-article-card--6e435";
export var outlet = "newsroomArticleCard-module--outlet--0c0fa";
export var readMore = "newsroomArticleCard-module--read-more--00725";